import 'normalize.css'

import { ThemeProvider, createGlobalStyle } from 'styled-components/macro'

import App from './App';
import { DefaultTheme } from './theme'
import { HashRouter } from "react-router-dom"
import { createRoot } from 'react-dom/client'

const GlobalStyle = createGlobalStyle`
  /* crimson-text-regular - latin */
  @font-face {
    font-family: 'Crimson Text';
    font-style: normal;
    font-weight: 400;
    src: local(''), url('/fonts/crimson-text-v19-latin-regular.woff2') format('woff2');
    font-display: swap;
  }
  /* crimson-text-italic - latin */
  @font-face {
    font-family: 'Crimson Text';
    font-style: italic;
    font-weight: 400;
    src: local(''), url('/fonts/crimson-text-v19-latin-italic.woff2') format('woff2');
    font-display: swap;
  }
  /* crimson-text-700 - latin */
  @font-face {
    font-family: 'Crimson Text';
    font-style: normal;
    font-weight: 700;
    src: local(''), url('/fonts/crimson-text-v19-latin-700.woff2') format('woff2');
    font-display: swap;
  }
  /* crimson-text-700italic - latin */
  @font-face {
    font-family: 'Crimson Text';
    font-style: italic;
    font-weight: 700;
    src: local(''), url('/fonts/crimson-text-v19-latin-700italic.woff2') format('woff2');
    font-display: swap;
  }

  body {
    font-family: 'Crimson Text', serif;
  }

  html {
    scroll-behavior: smooth;
  }
`

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <HashRouter>
    <ThemeProvider theme={DefaultTheme}>
      <GlobalStyle />
      <App />
    </ThemeProvider>
  </HashRouter>
)
